const experience = {
  work_experience: [
    {
      name: "CybertronPC",
      siteUrl: "https://www.cybertronpc.com",
      about: "CybertronPC is a custom PC integrator catering to gamers, business, home and server solutions. Owned and operated in the USA since January of 1997",
      startDate: "January 2021",
      endDate: "Present",
    },
    {
      name: "uleague",
      siteUrl: "http://uleague.org",
      about:
        "At uLeague we are looking to help every person achieve their professional goals and dreams. We are doing so by ensuring that every person gets to have access to the best content, expertise, and tools that are right for them. We do not believe in a one size fits all model; we believe in the exact opposite - no two humans are alike",
      startDate: "January 2020",
      endDate: "January 2021",
    },
    {
      name: "GraspStudios",
      siteUrl: "https://www.facebook.com/graspstudios/",
      about: "Grasp studios is a software house. At Grasp studios we offer web Design and Development, branding, FOH - Reservation/CRM Solution and Social Media Management & Content Creation.",
      startDate: "December 2018",
      endDate: "January 2020",
    },
    {
      name: "Tactful.ai",
      siteUrl: "https://tactful.ai",
      about: "Tactful.ai is a smart virtual shopping assistance technology that online merchants can seamlessly integrate into their sales channels and it is an end to end solution.",
      startDate: "July 2017",
      endDate: "December 2018",
    },
  ],
};

export default experience;
